import {
  COMPANY_FILTER_APPLY,
  COMPANY_FILTER_CHANGE,
  FETCH_SELECTED_COMPANY_DATA_ASYNC,
} from './constants'

const initialState = {
  loader: false,
  selectedCompany: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_FILTER_APPLY:
      return {
        ...state,
        selectedCompany: action.payload.selectedCompany || state.selectedCompany,
      }
    case COMPANY_FILTER_CHANGE:
      return {
        ...state,
        loader: true,
        selectedCompany: action.payload.selectedCompany || state.selectedCompany,
      }
    case FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS:
      return {
        ...state,
        loader: false,
      }
    default:
      return state
  }
}
